export class PlayerLocomotionTeleport {

    constructor() {
    }
}